export default "__VITE_ASSET__yj7SbneI__"